var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.001 22.1875C18.0751 22.1875 22.1885 18.0741 22.1885 13C22.1885 7.92588 18.0751 3.8125 13.001 3.8125C7.92686 3.8125 3.81348 7.92588 3.81348 13C3.81348 18.0741 7.92686 22.1875 13.001 22.1875ZM13.001 23.7188C18.9208 23.7188 23.7197 18.9198 23.7197 13C23.7197 7.0802 18.9208 2.28125 13.001 2.28125C7.08117 2.28125 2.28223 7.0802 2.28223 13C2.28223 18.9198 7.08117 23.7188 13.001 23.7188Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0213 7.89648H12.9796C12.4274 7.89648 11.9796 8.3442 11.9796 8.89648V8.93815C11.9796 9.49044 12.4274 9.93815 12.9796 9.93815H13.0213C13.5736 9.93815 14.0213 9.49044 14.0213 8.93815V8.89648C14.0213 8.3442 13.5736 7.89648 13.0213 7.89648Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0213 11.9798H12.9796C12.4274 11.9798 11.9796 12.4275 11.9796 12.9798V17.1048C11.9796 17.6571 12.4274 18.1048 12.9796 18.1048H13.0213C13.5736 18.1048 14.0213 17.6571 14.0213 17.1048V12.9798C14.0213 12.4275 13.5736 11.9798 13.0213 11.9798Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.4ef2e5b6.svg";
export { ForwardRef as ReactComponent };